/**
 * Valores por defecto globales de proyecto e IGV para líneas de productos.
 */
export function buildProductLineSettings({
  productsProjectEnabled,
  productsIgvEnabled,
  defaultProjectId = '',
  defaultHasIgv = true,
} = {}) {
  return {
    productsProjectEnabled: Boolean(productsProjectEnabled),
    productsIgvEnabled: Boolean(productsIgvEnabled),
    defaultProjectId: defaultProjectId ? String(defaultProjectId) : '',
    defaultHasIgv: defaultHasIgv !== false,
  };
}

export function applyProductLineDefaults(settings = {}) {
  const patch = {};

  if (settings.productsProjectEnabled && settings.defaultProjectId) {
    patch.project_id = String(settings.defaultProjectId);
  }

  if (settings.productsIgvEnabled) {
    patch.has_igv = settings.defaultHasIgv !== false;
  }

  return patch;
}

export function mergeProductLineDefaults(item, settings) {
  return { ...item, ...applyProductLineDefaults(settings) };
}

export function emptyStagingWithDefaults(createEmpty, settings, ...args) {
  return mergeProductLineDefaults(createEmpty(...args), settings);
}
